export default {
	get token() {
		return localStorage.getItem('token');
	},
	set token(value) {
		localStorage.setItem('token', value, 600000);
	},

	get user() {
		let token = localStorage.getItem('token');
		if (token == null) {
			localStorage.removeItem('user');
		}
		let obj = localStorage.getItem('user');
		if (obj == null) {
			return null;
		}
		return JSON.parse(obj);
	},
	set user(value) {
		if (value == null) localStorage.removeItem('user')
		else localStorage.setItem('user', JSON.stringify(value))
	}
}



// WEBPACK FOOTER //
// ./src/store/state.js